document.addEventListener("DOMContentLoaded", function () {
const select = document.querySelector("#variant-select");

// Graceful fallback if dropdown not found
if (!select) return;

const ingredientsBlocks = document.querySelectorAll(".mobile-ingredients__variant__ingredients");

select.addEventListener("change", function () {
    const selectedId = this.value;

    ingredientsBlocks.forEach((block) => {
        if (block.dataset.variantId === selectedId) {
            block.classList.add("is-active");
        } else {
            block.classList.remove("is-active");
        }
    });

});

// Optional: auto-select first valid variant
if (select.options.length > 1 && select.value === "") {
    select.selectedIndex = 1;
    const event = new Event("change");
    select.dispatchEvent(event);
}
});
